// extracted by mini-css-extract-plugin
module.exports = {"Invoice":"Invoices_Invoice__6YDL-"};